import {OperatorFunction, throwError, timeout} from 'rxjs';
import {TIMEOUT} from '../../CONST';
import {TimeoutError} from '../../errors/TimeoutError';

export function timeoutLikeABoss<T>(ms: number = TIMEOUT, msg: string = ``): OperatorFunction<T, T> {
    return timeout({
        first: ms,
        with: () => throwError(() => new TimeoutError(ms, msg))
    });
}